import { useState, useCallback, useEffect, useMemo } from "react";
import type { PointOfInterest } from "../types";
import { coordKey, isMappable } from "../utils/coords";

export function usePoiLayer(pois: PointOfInterest[]): {
  visiblePois: PointOfInterest[];
  selectedPoi: PointOfInterest | null;
  selectPoi: (poi: PointOfInterest | null) => void;
} {
  const [selectedPoi, setSelectedPoi] = useState<PointOfInterest | null>(null);

  const visiblePois = useMemo(() => {
    const mappable = pois.filter(isMappable);
    return mappable.filter(
      (poi, idx) =>
        mappable.findIndex(
          (p) => coordKey(p.lat, p.lng) === coordKey(poi.lat, poi.lng),
        ) === idx,
    );
  }, [pois]);

  useEffect(() => {
    setSelectedPoi((current) =>
      current && !pois.some((p) => p.id === current.id) ? null : current,
    );
  }, [pois]);

  const selectPoi = useCallback((poi: PointOfInterest | null) => {
    setSelectedPoi((current) =>
      poi !== null && current?.id === poi.id ? null : poi,
    );
  }, []);

  return { visiblePois, selectedPoi, selectPoi };
}
